module.exports = "https://cdn-b2c.dom.ru/b2c-domru/2.357.4/frontend/_next/static/images/advantages_1_L5-49b2fb4096572932ac7765ad6518e58c.webp";